
import React from 'react';
import { Link } from 'react-router-dom';
import { homeURL } from '../../config';

const Forbidden = () => {
    return (
        <div style={{ marginTop: "15rem", fontSize: "35px" }}>
            <h1 style={{ marginLeft: "55rem", fontWeight: "bold", fontSize: "55px" }}>403 FORBIDDEN</h1>
            <h1 style={{ fontSize: "45px", marginLeft: "52rem" }}>User is Forbidden from Content</h1>
            <a href={`${process.env.REACT_APP_BASE_DOMAIN_URL}/home`} target="_blank" rel="noreferrer"><h3 style={{ fontSize: "45px", marginLeft: "52rem" }}>Return to Home Page</h3></a>
            {/* <Link to={homeURL}><h3 style={{ fontSize: "45px", marginLeft: "52rem" }}>Return to Home Page</h3></Link> */}
        </div>
    );
}

export default Forbidden;